import React from 'react';

const TermsOfUse: React.FC = () => {
  return (
    <div className="m-5">
      <p>
        <a>
          <strong>Terms of Use</strong>
        </a>
      </p>

      <p>
        Welcome to the User Agreement for World Gem Trade Inc. (the `Company`)
        (the `Agreement`). This Agreement describes the terms and conditions
        applicable to the use of the World Gem Trade desktop application and
        associated domain https://secure.worldgemtrade.com (the `Application`)
        by authorized users. If you do not agree to be bound by the terms and
        conditions of this Agreement, do not use the Application or access our
        services.
      </p>

      <p>
        Use of the Application in any manner, as a Dealer (defined below),
        including browsing, activating an account with us, posting Listings and
        receiving news bulletins by e-mail from the Company is governed by this
        Agreement.
      </p>

      <p>
        The Company reserves the right to modify or change the Agreement at any
        time without prior written notice to the Dealer and it is the
        responsibility of the Dealer to read the Agreement carefully each time
        they access the Application.
      </p>

      <p>
        <strong>1. Dealers are the Only Authorized Users</strong>
      </p>

      <p>
        <strong>1.1 Dealer.</strong> A Dealer is a person or company who has
        provided its name, telephone number, e-mail address, postal address and
        initial subscription fee to the Company. A Dealer can submit a Listing
        for the Company to post on the Application.
      </p>

      <p>
        <strong>1.2 Dealer Eligibility.</strong> For a Dealer to register, it
        must have a valid license issued by the governmental, regulatory, or
        jewelry industry association body in the province, state, or territory
        in which the Dealer operates, to sell jewelry related products or
        services (the `Dealer License`). The Company reserves the right to
        request such documentation to confirm a valid and subsisting Dealer
        License at any time. By registering as a Dealer, you represent that you
        have the authority to bind the entity to this Agreement.
      </p>

      <p>
        <strong>1.3 Dealer Information is Business Information.</strong> Dealer
        agrees that any and all information submitted pursuant to this Agreement
        is business information. Without limiting the foregoing, Dealer agrees
        any and all information submitted pursuant to this Agreement including
        name, telephone number, e-mail address and postal address are business
        information. Dealer specifically represents to the Company that any and
        all information submitted pursuant to this Agreement is not personal
        information.
      </p>

      <p>
        <strong>1.4 Dealers must be over 18 years of age.</strong> You hereby
        confirm that this is the fact. If we find out a Dealer is in fact a
        minor, we will reject any submitted Listing
      </p>

      <p>
        <strong>2. The Company is a Venue.</strong>
      </p>

      <p>
        <strong>2.1 The Company is not a Seller or Buyer.</strong> The Company
        is not a Seller or Buyer. The Application acts as a venue to allow
        Dealers to list each Dealer`s inventory and offer and sell jewelry
        related products or services (`Seller Dealer`), and for Dealers to buy
        inventory (`Buyer Dealer`). The Company is not involved in the actual
        transaction between Buyer Dealers and Seller Dealers. As a result, the
        Company has no control over the quality, safety or legality of the items
        advertised the truth or accuracy of the listings, the ability of sellers
        to sell items or the ability of buyers to pay for items. The Company
        cannot ensure that a Buyer Dealer and Seller Dealer will actually
        complete a transaction.
      </p>

      <p>
        <strong>2.2 Identity Verification.</strong> Because user authentication
        is difficult, the Company does not confirm each user`s purported
        identity. The Company encourages you to communicate directly with
        potential Dealers and to use your common sense and judgment in dealing
        with them.
      </p>

      <p>
        <strong>2.3 Release.</strong> Because the Company is a venue, in the
        event you have a dispute with one or more Dealers, you release the
        Company (and its parent and subsidiaries and joint ventures and all such
        persons, officers, directors, agents, employees, and associations) from
        all claims, demands, and damages (actual and consequential) of every
        kind, nature, known and unknown, suspected and unsuspected, disclosed
        and undisclosed, arising out of or in any way connected with such
        disputes.
      </p>

      <p>
        <strong>2.4 Information control.</strong> We do not control the
        information provided by other Dealers, which is made available through
        the Application. You may find other Dealer`s information to be
        offensive, harmful, inaccurate, or deceptive.
      </p>

      <p>
        <strong>2.5 Please use caution</strong> , common sense and practice safe
        trading when using the Application. Please note there are also risks of
        dealing with foreign nationals, underage persons or persons acting under
        false pretence. By using this Application, you agree to accept such
        risks and the Company is not responsible for the acts or omissions of
        its users.
      </p>

      <p>
        <strong>2.6 Monitoring.</strong> World Gem Trade has the right, but not
        the obligation, to monitor or log any World Gem Trade activity or use of
        the service. You consent to any such monitoring and logging that is
        necessary to satisfy any law, regulation or other government request, or
        to enhance operation efficiencies, to improve service levels, to assess
        client satisfaction, or to protect World Gem Trade or its clients from
        unwanted use of certain services or application. World Gem Trade
        reserves the right to delete, remove or block access to any internet
        capability, content, information or third party products or services
        available or transmitted through the service that World Gem Trade, in
        its sole discretion, believes is unacceptable or in violation of these
        terms and conditions.
      </p>

      <p>
        <strong>3. Subscription for Service and Transaction Payment</strong>
      </p>

      <p>
        <strong>3.1 Monthly Subscription Fees.</strong> Dealers shall pay a
        monthly subscription fee as outlined in the fee schedule that is
        currently published by World Gem Trade Inc. by way of pre-authorized
        payment, credit card or monthly invoice.
      </p>

      <p>
        <strong>3.2 Charges and Payment.</strong> All service use, access fees
        and other charges, including taxes, are due and payable as specified by
        World Gem Trade on invoices to the company paying the bill or as
        otherwise arranged by World Gem Trade. Charges will be deemed to be
        correct if not disputed by you within thirty (30) days of the invoice
        dated. Your service use, access fees and other charges will continue
        until the service is terminated. If the company changes its place of
        business to another province or country a different World Gem Trade rate
        plan may apply to the service.
      </p>

      <p>
        <strong>3.3 Termination / Suspension of service.</strong> Unless
        otherwise agreed, you may terminate your service at any time by
        providing World Gem Trade with thirty (30) days written notice. Upon
        termination of service, and before the end of the agreed upon contract
        date, a termination charge equivalent to the lesser of 50% of the total
        billable contract rate for the remaining months in the contract or
        $2,000.00 will be assessed upon termination.
      </p>

      <p>
        <strong>
          3.4 World Gem Trade may suspend or terminate the service
        </strong>{' '}
        and this agreement at any time, without any notice or liability if you
        fail to pay any amount that is overdue by thirty (30) days.
      </p>

      <p>
        <strong>3.5 Transfer of Account.</strong> A Dealer account cannot be
        transferred or sold to another party without the expressed written
        permission of the Company.
      </p>

      <p>
        <strong>
          4. Content, Copyrights and Limitations on Use of Content.
        </strong>
      </p>

      <p>
        <strong>4.1 Content.</strong> The Application`s content includes text,
        graphics, logos, button icons, images, universal resource locators
        (`URLs`) or any other information posted from time to time on the
        Application by the Company, and includes the arrangement of text,
        graphics, logos, button icons, images or URLs on the Application.
      </p>

      <p>
        <strong>4.2 Copyrights.</strong> The Content is the exclusive property
        of the Company and is protected by Canadian copyright laws. All rights
        not expressly granted in this Agreement are reserved.
      </p>

      <p>
        <strong>4.3 Use of Content.</strong> The Content may be displayed,
        reformatted and printed for your personal use only. By using the
        Application, you agree not to reproduce, retransmit, distribute,
        disseminate, display, sell, publish, broadcast or circulate the Content
        to anyone without the prior written consent of the Company.
      </p>

      <p>
        <strong>4.4 The Company reserves the right not to post,</strong> or to
        remove any such data or materials without notice, without liability to
        the Company. If the Company is made aware of Dealer content that is
        potentially (i) libelous, defamatory, scandalous, or otherwise
        unacceptable, undesirable or objectionable, or (ii) in violation of any
        law, regulation, or rights of a third party, including, but not limited
        to, rights under the copyright law and prohibitions on libel, slander
        and invasion of privacy, then the Company may, in its sole discretion,
        investigate the charge and determine if removal of the content is
        warranted.
      </p>

      <p>
        <strong>5. Disclaimer of Warranties and Liability</strong>
      </p>

      <p>
        <strong>5.1</strong> Due to the number of sources from which the Content
        may be obtained, and the inherent hazards of electronic distribution,
        there may be delays, omissions or inaccuracies in the Content and the
        Application.
      </p>

      <p>
        <strong>5.2</strong> While the Listings posted to the Application become
        the property of the Company, they still represent the information of
        Dealers. The Company does not take responsibility for the accuracy and
        completeness of Listings. It is the responsibility of the end user to
        evaluate the accuracy, completeness, and/or usefulness of any
        information, opinion, advice, or other content found on the Application.
        The Company cannot guarantee that Dealers presenting themselves as
        sellers are actually sellers, though the Company has policies in place
        to prevent this kind of misuse of our Application. If the Company finds
        a Dealer has submitted a false or misleading Listing, the Company will
        delete the Listing from the Application. The Company reserves the right
        to reject subsequent submissions from such Dealers.
      </p>

      <p>
        <strong>5.3 No Warranty.</strong> The company, its subsidiaries,
        officers, directors, employees and suppliers provide the application and
        services `as is` and without any representation, warranty or condition,
        express, implied or statutory. We specifically disclaim any implied
        representation, warranties of title, merchantability, merchantable
        quality, fitness for a particular purpose and non-infringement, and
        those arising by law or through a course of dealing or usage of trade,
        unless specifically required by law.
      </p>

      <p>
        <strong>5.4 Liability Limit.</strong> In no event shall the Company, its
        subsidiaries, officers, directors, employees or its suppliers be liable
        for lost profits or any special, incidental, consequential, indirect or
        punitive damages arising out of or in connection with our application.
        If you are dissatisfied with the application and the content thereon, or
        the terms and conditions, your sole and exclusive remedy is to
        discontinue use of the application. If any portion of this limitation is
        found to be invalid or unenforceable for any reason, then the Company`s
        total liability to you shall in no event exceed one hundred dollars
        ($100.00).
      </p>

      <p>
        <strong>6. Use of Application.</strong>
      </p>

      <p>
        <strong>6.1 Listing Submissions.</strong> Dealers must be legally able
        to sell the item(s) submitted for Listing on the Application. Dealers
        must describe items and all terms of sale on the listing page of the
        Application. Dealer`s Listings may only include text descriptions,
        graphics, pictures and other content relevant to the sale of that item.
        All listed items must be listed in an appropriate category.
      </p>

      <p>
        <strong>6.1.1</strong> Listings on the Application are based on
        information provided by Dealers about their inventory or by the Company
        employees who have contacted Dealers to submit a Listing. Dealers may
        not post or otherwise make available on the Application any material
        that is protected by a copyright, trade-mark or other proprietary right
        without the expressed permission of the owner. Dealers agree to assume
        sole liability for any damage resulting from infringement of any
        copyrights, trade-marks, proprietary rights or any other harm resulting
        from such a submission.
      </p>

      <p>
        <strong>6.1.2</strong> By providing a Listing to the Company, Dealers
        agree all information submitted to the Application is the property of
        the Company and can be used for any purpose. The Company has the
        royalty-free, perpetual, irrevocable, non-exclusive right and license to
        use, reproduce, modify, adapt, publish, translate and distribute
        worldwide and/or incorporate into other works in any form, media or
        technology now known or hereafter developed for the full term of any
        copyright that may exist in such material. The Company reserves the
        right to paraphrase or otherwise edit Listings.
      </p>

      <p>
        <strong>6.2 Validation of Dealer Listings.</strong> If the Company has
        any concerns whatsoever about a Dealer`s Listing or questions about the
        validity of your e-mail address and phone number provided upon signing
        up, the Company will place the Listing on hold. The Company will not
        incorporate your Listing until any questions are resolved. The Company
        reserves the right to use a Dealer`s phone number and e-mail address for
        contact should any questions about a Dealer`s Listing arise. Dealers
        must respond to this phone or e-mail inquiry within five days or such
        Dealer`s Listing will be invalidated. If the Company`s concerns are not
        resolved to the Company`s satisfaction, the Company still reserves the
        right to invalidate such Listing.
      </p>

      <p>
        <strong>6.3 Prohibited Activities.</strong> Dealers agree to use this
        Application only in a manner that is legal, proper, and related to the
        purposes of the Application. Dealers agree not to use the Application in
        a way that would undermine its functioning and/or disrupt the service
        for other Dealers or the Company. Such activities include, but are not
        limited to, submitting multiple Listings (as defined above), submitting
        fraudulent Listing, creating alias identities to post multiple Listings,
        impersonating another person or entity, jamming discussion boards and
        overloading the system with malicious intent. The Company reserves the
        right to refuse service and terminate registration of any Dealer found
        to be or whom the Company thinks may be engaging in such activities,
        solely at the discretion of the Company.
      </p>

      <p>
        <strong>6.4 Lawful Use.</strong> The Application may only be used for
        lawful purposes. The Company specifically prohibits use of the
        Application for unlawful purposes and reserves the right to refuse
        service to any Dealer found to be doing so.
      </p>

      <p>
        <strong>6.5 Use of Application Content.</strong> Dealers may use or
        download Content from this Application. Dealers must retain copyrights
        and proprietary notices on downloaded Content. Dealers shall not modify,
        publish, distribute or sell or in any way exploit the Content without
        the written permission of the Company. Dealers shall not use any Content
        for commercial purposes, including, but not limited to, the compilation
        of any e-mail, addresses, phone numbers or URLs found on the
        Application.
      </p>

      <p>
        <strong>6.6 No Endorsement.</strong> This Application compiles Dealer
        Listings; Listings published do not convey any recommendations or
        endorsement of any specific Dealer, company or individual by the
        Company.
      </p>

      <p>
        <strong>6.7 Access to Dealer Account/ Online Services.</strong> You
        shall be responsible for maintaining the confidentiality of your World
        Gem Trade account, (including all login names and passwords) and you are
        similarly responsible for all uses of your World Gem Trade account
        whether or not such uses are actually authorized by you. World Gem Trade
        may, in its sole discretion, alter, limit or delete any part of the
        online services at any time.
      </p>

      <p>
        <strong>6.8</strong> World Gem Trade is not responsible for any act or
        omission of any third party service, application or content providers.
      </p>

      <p>
        <strong>7. Third Party Content.</strong>
      </p>

      <p>
        <strong>7.1</strong> The Application is a venue for information supplied
        by Dealers (`Third Party Content`). The Company has no prior review
        process or editorial control over Third Party Content. Any opinions,
        advice, statements, services, offers or other information or content
        expressed or made available by Dealers are those of the respective
        Dealer and not of the Company. Neither the Company nor any Dealer
        guarantees the accuracy, completeness, and usefulness of any Third Party
        Content.
      </p>

      <p>
        <strong>7.2</strong> 7.1.As specific individual Dealer authentication is
        sometimes difficult, or even impossible, the Company cannot and does not
        confirm the identity of each Dealer and whether or not any particular
        user is authorized to act on behalf of any Dealer. In addition, note
        there are risks of dealing with underage persons, foreign nationals and
        persons acting under false pretense. Dealers must be careful in dealing
        with other Dealers to avoid fraud and other personal and economic risks.
      </p>

      <p>
        <strong>8. Links to Third Party Sites.</strong>
      </p>

      <p>
        <strong>8.1</strong> The Content may include links between this
        Application and third party sites, such as company sites, on the World
        Wide Web that are not under the control or maintained by the Company.
        Such links do not necessarily constitute an endorsement by the Company
        of those sites. The Company undertakes no obligation to monitor such
        sites, and Dealer agrees that the Company is not responsible for such
        sites or any technical or other problems associated with any such third
        party site, links or use.
      </p>

      <p>
        <strong>8.2</strong> Dealers further agree in the event you establish a
        link from any other site to the Application, you will immediately
        discontinue such a link upon receiving written notice from the Company
        of its objection to any such link.
      </p>

      <p>
        <strong>9. Termination.</strong>
      </p>

      <p>
        <strong>9.1</strong> The Company reserves the right to refuse service
        and to terminate this Agreement with any Dealer at any time. The effect
        of the termination will prevent the Dealer from submitting Listings,
        receiving e-news bulletins by e-mail, accessing the Application, or any
        other services provided by the Company through the Application to
        Dealers. The Company may refuse service in situations including, but not
        limited to, violation of this Agreement, submission of false Listings
        and posting Listings containing offensive or defamatory language.
      </p>

      <p>
        <strong>10. Indemnity.</strong>
      </p>

      <p>
        <strong>10.1</strong> By becoming a Dealer you agree to indemnify the
        Company, its officers, agents, partners and employees from any and all
        claims or damages, including reasonable lawyer`s fees, made by third
        parties due to, or arising out of the use of the Application or
        connection to the Application; Content submitted, posted or transmitted
        by a Dealer though the Application; violation of the Agreement; or any
        violation of the rights of another.
      </p>

      <p>
        <strong>11. Dealer Passwords</strong>
      </p>

      <p>
        <strong>11.1</strong> Dealer accounts may be accessed only by use of a
        unique login name and password. The use of a password does not restrict
        access by the Company to the password-protected information. Login names
        and passwords may not be shared. For security reasons, you must keep
        your login name and password confidential and not disclose them to any
        person or permit any other person to use them, except by an authorized
        Company representative. The Company advises that passwords are
        non-obvious, hard-to-guess, and confidential and changed on a regular
        basis, and you must log-out at the end of each session.
      </p>

      <p>
        <strong>11.2</strong> Dealers are solely responsible and liable for any
        use and misuse of your login name and password and for all activities
        that occur under your login name and password. You must ensure all uses
        of your login name and password comply with this Agreement.
      </p>

      <p>
        <strong>11.3</strong> Dealers must immediately notify the Company of any
        unauthorized use of your login name or password, or if you know or
        suspect your login name or password has been lost or stolen, has become
        known to any other person, or has been otherwise compromised.
      </p>

      <p>
        <strong>11.4</strong> All login names and passwords remain the property
        of the Company, and may be cancelled or suspended at any time by the
        Company without any notice or liability to you or any other person. The
        Company is not under any obligation to verify the actual identity or
        authority of the user of any login name or password.
      </p>

      <p>
        <strong>11.5</strong> You must respond promptly to all e-mail and other
        correspondence from the Company, including without limitation e-mail and
        correspondence concerning complaints or concerns regarding your use of
        your login name or password or your use of the Web Site.
      </p>

      <p>
        <strong>11.6</strong> The security and privacy provided by passwords is
        not complete, and can be circumvented. Your use of passwords is at your
        own risk.
      </p>

      <p>
        <strong>
          12. Dealer Management System (DMS) Interface Participation.
        </strong>
      </p>

      <p>
        <strong>12.1</strong> All dealers and end users that partake of DMS
        interface programs for purposes of updating inventory on World Gem Trade
        are bound by the following guidelines in respect to their DMS provider.
      </p>

      <p>
        <strong>12.2</strong> Dealers agree and understand the Company is not
        responsible for incorrect data entry as it pertains to the dealer
        management system and it is the sole responsibility of the dealer to
        correct and/or make accurate incorrect data.
      </p>

      <p>
        <strong>12.3.1</strong> Authorize the operation of the Interface only
        with the Interfaced Product and only for each license fee that is paid.
      </p>

      <p>
        <strong>12.3.2</strong> Authorize the Qualified End User to make one
        copy of the Interfaced Product and Interface for backup purposes only,
        and prohibit further copying or disassembly, decompilation or reverse
        engineering of the Interfaced Product and the Interface;
      </p>

      <p>
        <strong>12.3.3</strong> Reserve to the Company all rights, title and
        interest in and to Interfaced Product and the Interface;
      </p>

      <p>
        <strong>12.3.4</strong> Product(s) provided under this Agreement contain
        portions of program code owned by third party licensors and such
        licensors will be entitled to enforce this License as an intended third
        party beneficiary and the obligations of the licensee cannot be modified
        or terminated without the written consent of such third party licensors.
        Licensee shall not disclose any passwords or other security information
        that are related to the Interface or other software licensed by this
        License.
      </p>

      <p>
        <strong>12.3.5</strong> In no event will any licensor be liable for
        indirect, incidental, consequential or exemplary damages arising from
        use, or inability to use Interface(s), even if they knew of the
        possibility of such damages.
      </p>

      <p>
        <strong>12.3.6</strong> All licensors disclaim all warranties, including
        (without limitation) any warranties of merchant ability or fitness for a
        particular purpose.
      </p>

      <p>
        <strong>12.3.7</strong> The End User license agreement and all rights to
        use or maintain possession of the Interfaced Product and the Interface
        will terminate immediately upon the Qualified End User`s breach of any
        material provision of such agreement.
      </p>

      <p>
        <strong>12.3.8</strong> Each party will, at a minimum, implement and
        maintain appropriate administrative, technical, and physical safeguards
        reasonably designed to: (a) ensure against any anticipated threats or
        hazards to the security or integrity of the Member Information; and (b)
        protect against unauthorized access to or use of the Customer
        Information that could result in substantial harm or inconvenience to
        the Qualified End User or the individual who is the subject of Customer
        Information.
      </p>

      <p>
        <strong>12.3.9</strong> Each party may disclose Member Information, when
        required, pursuant to any federal or state law or regulation or rules or
        regulations of any governmental agency. These provisions shall apply
        during the term and after the termination of the End User License
        Agreement.
      </p>

      <p>
        <strong>12.3.10</strong> Your business data belongs to you, and we
        respect and support your right to protect your business data. By signing
        below, you give us the right to share required business data with
        required third parties only if sharing the required business data is
        necessary in order to provide our Product(s) to you. Any other use of
        your business data is subject to our policies set forth in this End User
        License Agreement. Your signature on this End User License Agreement
        authorizes us to use your business data in the manner specified herein,
        and we represent that we will only use your business data in compliance
        with your authorization.
      </p>

      <p>
        <strong>13. Miscellaneous.</strong>
      </p>

      <p>
        <strong>13.1 No Agency or Partnership.</strong> The parties to this
        Agreement are Independent Contractors. Neither party may direct or
        control the day-to-day activities of the other; neither party may create
        or assume any obligation on behalf of the other.
      </p>

      <p>
        <strong>13.2 Assignment.</strong> The Company may assign any or all of
        its rights hereunder to any party without the consent of Dealer. Dealer
        shall not assign this Agreement or any of its rights or obligations
        without the prior written consent of the Company, and any such attempted
        assignment will be void and unenforceable. This Agreement will be
        binding upon the parties` respective successors in interest and
        permitted assigns.
      </p>

      <p>
        <strong>14. Entire Agreement.</strong>
      </p>

      <p>
        <strong>14.1</strong> This Agreement, together with the Privacy Policy
        of the Application, constitutes the entire agreement between the
        Application and Dealers regarding the subject matter of the agreement,
        and supersedes all prior or contemporaneous communications whether
        electronic, oral or written between the Application and Dealers with
        respect to such subject matter.
      </p>

      <p>
        <strong>15. Governing Law.</strong>
      </p>

      <p>
        <strong>15.1</strong> The laws of all provinces and states and the laws
        of all countries shall govern the Agreement as well as any use of the
        Application, therein.
      </p>
    </div>
  );
};

export default TermsOfUse;
